import React from 'react'
import Image from 'next/image'
import { IArticle } from '@/api/interfaces/IArticle'
import { Card } from '../Card'
import { FollowButton } from '../buttons/FollowButton'
import { Icon } from '../Icon'
import { WithT } from '@/locales/types'
import Link from 'next/link'
import { ImageWithFallback } from '../ImageWithFallback'

import DefaultProfile from '@/public/images/v2/default/profile.png'

interface ArticleRelatedVirtualCard {
  item: IArticle.IRelatedUser
}

function ArticleRelatedVirtualCard({
  item,
  translations,
}: WithT<ArticleRelatedVirtualCard>) {
  return (
    <Link href={`/@${item.username}`}>
      <Card className="flex justify-between items-center !p-3">
        <div className="flex gap-4 items-center">
          <ImageWithFallback
            src={item.profileImage?.url || DefaultProfile}
            alt="버추얼 이미지"
            width={48}
            height={48}
            className="object-cover aspect-auto rounded-2xl"
            fallback={DefaultProfile.src}
          />

          <div className="flex flex-col gap-1">
            <div className="flex gap-1 items-center">
              <span className="text-subtitle2 font-bold">{item.nickname}</span>
              <Icon name="creator-badge" size={14} className="!text-key" />
            </div>

            <p className="text-body2 font-normal line-clamp-1">
              {item.introduction}
            </p>
          </div>
        </div>

        <FollowButton
          user={item}
          isFollow={item.isFollowing}
          hideCount
          translations={translations}
        />
      </Card>
    </Link>
  )
}

export default ArticleRelatedVirtualCard
